import React from 'react'

import FormURL from 'lemon-campaign-ui/lib/organisms/FormURL'

export default ({ component, defaults, recursive, handlers }) => {
  return (
    <FormURL
      {...defaults}
      fallbackSubmitHandler={(rawValues) => {
        handlers.formSubmit(rawValues, component)
      }}
      onFormSubmit={(rawValues) => {
        handlers.formSubmit(rawValues, component, true)
      }}
      onEventScheduled={(...data) => {
        handlers.thirdPartyInteraction('calendly', component)
      }}
      onSubmit={(rawValues) => {
        handlers.formSubmit(rawValues, component, true)
      }}
      boxed={!component.parentId}
      url={component.content.url}
    >
      {recursive(component.components)}
    </FormURL>
  )
}
